import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonRelationDTOBase } from "./PersonRelationDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedBase } from "./TrackedBase";

export class PersonRelationStaff implements PersonRelationDTOBase, TrackedBase {
  constructor(public readonly relationId: number, public readonly aPersonId: PersonStaff | null, public readonly bPersonId: PersonStaff | null, public readonly typeId: number | null, public readonly aTitleOverride: string | null, public readonly bTitleOverride: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly aPersonKey: number | null, public readonly aPersonName: string | null, public readonly bPersonKey: number | null, public readonly bPersonName: string | null) {
    this.cbiServiceContext = null;
    this.aPersonIdLoaded = this.aPersonId != null;
    this.aPersonIdCached = this.aPersonId;
    this.bPersonIdLoaded = this.bPersonId != null;
    this.bPersonIdCached = this.bPersonId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private aPersonIdLoaded: boolean;
  private aPersonIdCached: PersonStaff | null;
  private bPersonIdLoaded: boolean;
  private bPersonIdCached: PersonStaff | null;
  async aPersonIdLazy(): Promise<PersonStaff | null> {
    if (!this.aPersonIdLoaded) {
      this.aPersonIdCached = await this.cbiServiceContext!.personService().getPersonRelationStaffAPersonId(this.relationId);
      this.aPersonIdLoaded = true;
    }
    return this.aPersonIdCached;
  }
  async bPersonIdLazy(): Promise<PersonStaff | null> {
    if (!this.bPersonIdLoaded) {
      this.bPersonIdCached = await this.cbiServiceContext!.personService().getPersonRelationStaffBPersonId(this.relationId);
      this.bPersonIdLoaded = true;
    }
    return this.bPersonIdCached;
  }
}
